export const SIGN_IN_TRANSLATE = {
    signIn: {
        breadcrumbName: "Iniciar sesión",
        form: {
            title: "Iniciar sesión",
            fields: {
                login: {
                    label: "Usuario",
                    placeholder: "Ingrese su usuario"
                },
                password: {
                    label: "Contraseña",
                    placeholder: "Ingrese su contraseña"
                }
            },
            actions: {
                save: {
                    text: "Iniciar sesión"
                }
            }
        }
    },
}
